"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chunk = void 0;
const support_1 = require("../support");
const Tile_1 = require("./Tile");
const persistence_1 = require("../persistence");
class Chunk {
    constructor(size, contents, position) {
        this.size = size;
        this.contents = contents;
        this.position = position;
    }
    static generate(position, size, probability) {
        let contents = [];
        size.iterate1d(((i) => {
            contents[i] = new Tile_1.Tile(support_1.indexToPos(i, size), Math.random() < probability, false);
        }));
        return new Chunk(size, contents, position);
    }
    static load(position, size, persistedChunk) {
        const contents = [];
        console.log(persistedChunk);
        size.iterate2d((_, __, pos) => {
            const i = support_1.posToIndex(pos, size);
            const persistedTile = persistedChunk.tiles[i];
            contents[i] = new Tile_1.Tile(pos, persistedTile.mine, persistedTile.opened, persistedTile.flaggedBy != null);
        });
        return new Chunk(size, contents, position);
    }
    getSize() {
        return this.size;
    }
    getPosition() {
        return this.position;
    }
    getTiles() {
        return this.contents.map((tile, index) => tile.calculateNumber(support_1.neighbors(this.contents, support_1.indexToPos(index, this.size), this.size)));
    }
    getActualTiles() {
        return this.contents;
    }
    getTile(position) {
        return this.contents[support_1.posToIndex(position, this.size)];
    }
    open(position) {
        const tile = this.contents[support_1.posToIndex(position, this.size)];
        tile.open();
        const neighborTiles = support_1.neighbors(this.contents, position, this.size);
        return tile.calculateNumber(neighborTiles);
    }
    isOpen(position) {
        return this.contents[support_1.posToIndex(position, this.size)].isOpen();
    }
    flag(position) {
        this.contents[support_1.posToIndex(position, this.size)].flag();
    }
    toPersistent() {
        return new persistence_1.PersistedChunk(this.position, this.contents.map(tile => {
            if (tile.isFlagged()) {
                return persistence_1.PersistedTile.flagged('anonymous', 'default');
            }
            if (tile.isOpen()) {
                return persistence_1.PersistedTile.opened(tile.isMine());
            }
            return persistence_1.PersistedTile.closed(tile.isMine());
        }));
    }
}
exports.Chunk = Chunk;
//# sourceMappingURL=Chunk.js.map